import { createContext, useState } from 'react'

const UserContext = createContext({ userState: { isAuth: false, token: null, userId: null }, setUserState: () => { } })

export function UserContextProvider({ children }) {
    const [userState, setUserState] = useState({ isAuth: false, token: null, userId: null })

    const context = { userState, setUserState }

    return (
        <UserContext.Provider value={context}>
            {children}
        </UserContext.Provider>)
}

export default UserContext